// extracted by mini-css-extract-plugin
module.exports = {"container":"_1BvdTi","text":"_3EIwKy","link":"_3nPH8w","button":"_2XWrmB"};